"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GoogleMapsBox_1 = __importDefault(require("./GoogleMapsBox"));
var ContactChooser_1 = __importDefault(require("./ContactChooser"));
/**
 * Location (service) finder filter component.
 *
 * @author Malte Schellhardt <malte.schellhardt@wendweb.de>
 */
var LocationFinderFilter = /** @class */ (function () {
    /**
     * Constructor.
     */
    function LocationFinderFilter() {
        var _this = this;
        this.CONTENT_ELEMENT_DATA = 'data-location-finder-content-element';
        this.CONTENT_ELEMENT_UID_DATA = 'data-location-finder-content-element-uid';
        this.FILTER_FORM_DATA = 'data-location-finder-filter-form';
        this.FILTER_FORM_SERVICE_LOCATION_CHECKBOX_DATA = 'data-location-finder-service-checkbox';
        this.FILTER_FORM_PRODUCTGROUP_SELECT = 'data-location-finder-productgroup-select';
        this.FILTER_FORM_PRODUCTGROUP_SELECT_URL = 'data-location-finder-productgroup-select-url';
        this.FILTER_FORM_PRODUCTLINES_DATA = 'data-location-finder-filter-productlines';
        this.FILTER_SELECT_ACTION_DATA = 'data-location-finder-filter-select-action';
        this.FILTER_PRELOADING_DATA = 'data-location-finder-filter-preloading';
        this.FILTER_RESULT_DATA = 'data-location-finder-filter-result';
        this.FILTER_SUBMIT = 'data-location-finder-filter-submit';
        this.FILTER_MAP = 'data-locationfinder-map';
        this.FILTER_MAP_PLACEHOLDER = 'data-map-placeholder';
        var locationFinderElements = document.querySelectorAll('[' + this.CONTENT_ELEMENT_DATA + ']');
        locationFinderElements.forEach(function (contentElement) {
            var contentElementUid = contentElement.getAttribute(_this.CONTENT_ELEMENT_UID_DATA);
            var filterForm = contentElement.querySelector('[' + _this.FILTER_FORM_DATA + ']');
            var preloadingElement = contentElement.querySelector('[' + _this.FILTER_PRELOADING_DATA + ']');
            var resultElement = contentElement.querySelector('[' + _this.FILTER_RESULT_DATA + ']');
            var productLineElement = contentElement.querySelector('[' + _this.FILTER_FORM_PRODUCTLINES_DATA + ']');
            var productGroupSelectElement = contentElement.querySelector('[' + _this.FILTER_FORM_PRODUCTGROUP_SELECT + ']');
            var filterSubmit = contentElement.querySelector('[' + _this.FILTER_SUBMIT + ']');
            if (contentElementUid && filterForm && preloadingElement && resultElement) {
                var serviceLocationCheckbox_1 = filterForm.querySelector('[' + _this.FILTER_FORM_SERVICE_LOCATION_CHECKBOX_DATA + ']');
                serviceLocationCheckbox_1.addEventListener('change', function (event) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.actualizeCountrySelectOptions(event, productLineElement, filterForm)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                }); });
                productGroupSelectElement.addEventListener('change', function () { return __awaiter(_this, void 0, void 0, function () {
                    var url, formData;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(!productGroupSelectElement.disabled && productGroupSelectElement.value != '-1')) return [3 /*break*/, 2];
                                url = productGroupSelectElement.getAttribute(this.FILTER_FORM_PRODUCTGROUP_SELECT_URL);
                                formData = new FormData(filterForm);
                                // disable submit if product group select shows specific product group
                                filterSubmit.disabled = true;
                                return [4 /*yield*/, this.populateProductLineRadio(url, formData, preloadingElement, productLineElement)];
                            case 1:
                                _a.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                // enable submit if product group select shows all groups
                                filterSubmit.disabled = false;
                                productLineElement.innerHTML = '';
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                }); });
                // Event delegation for product series radio
                productLineElement.addEventListener('change', function (event) {
                    var target = event.target;
                    // Enable form submit if product series is selected
                    if (target.matches('[data-location-finder-product-radio]')) {
                        filterSubmit.disabled = false;
                    }
                });
                filterForm.addEventListener('submit', function (event) { return __awaiter(_this, void 0, void 0, function () {
                    var url, formData, response, _a, error_1;
                    var _b, _c;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0:
                                event.preventDefault();
                                preloadingElement.classList.remove('d-none');
                                url = filterForm.getAttribute('action');
                                formData = new FormData(filterForm);
                                _d.label = 1;
                            case 1:
                                _d.trys.push([1, 4, , 5]);
                                return [4 /*yield*/, fetch(url, {
                                        method: 'POST',
                                        headers: {
                                            'content-type': 'application/json',
                                        },
                                        body: JSON.stringify({
                                            contentElementUid: contentElementUid,
                                            serviceLocation: serviceLocationCheckbox_1.checked,
                                            country: formData.get('tx_wwproject_locationfinder[country]'),
                                            productGroup: formData.get('tx_wwproject_locationfinder[productGroup]'),
                                            productLine: formData.get('productLine'),
                                        }),
                                    })];
                            case 2:
                                response = _d.sent();
                                _a = resultElement;
                                return [4 /*yield*/, response.text()];
                            case 3:
                                _a.innerHTML = _d.sent();
                                // Consent-Status auf den neu gerenderten DOM anwenden:
                                (_b = window.checkExternalMediaConsentAndToggleMap) === null || _b === void 0 ? void 0 : _b.call(window, resultElement);
                                preloadingElement.classList.add('d-none');
                                this.scrollToResults();
                                // Nur initialisieren, wenn Consent ok ist
                                if (((_c = window.OnetrustActiveGroups) !== null && _c !== void 0 ? _c : '').includes('C0010')) {
                                    new GoogleMapsBox_1.default();
                                }
                                new ContactChooser_1.default();
                                return [3 /*break*/, 5];
                            case 4:
                                error_1 = _d.sent();
                                throw new Error('An error occurred during the fetch request for the location filtering: ' + error_1.message);
                            case 5: return [2 /*return*/];
                        }
                    });
                }); });
            }
            else {
                throw new Error('DOM elements for the filter function of the locations are missing.');
            }
        });
        this.scrollToResults();
    }
    LocationFinderFilter.prototype.populateProductLineRadio = function (url, formData, preloadingElement, productLineElement) {
        return __awaiter(this, void 0, void 0, function () {
            var response, _a, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'content-type': 'application/json',
                                },
                                body: JSON.stringify({
                                    productGroup: formData.get('tx_wwproject_locationfinder[productGroup]'),
                                }),
                            })];
                    case 1:
                        response = _b.sent();
                        preloadingElement.classList.remove('d-none');
                        _a = productLineElement;
                        return [4 /*yield*/, response.text()];
                    case 2:
                        _a.innerHTML = _b.sent();
                        preloadingElement.classList.add('d-none');
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        throw new Error('An error occurred during the fetch request for the location filtering: ' + error_2.message);
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     *
     * @param event
     * @param productLineElement
     * @param filterForm
     * @private
     */
    LocationFinderFilter.prototype.actualizeCountrySelectOptions = function (event, productLineElement, filterForm) {
        return __awaiter(this, void 0, void 0, function () {
            var target, form, element, productGroupSelect, countrySelect, url, formData, response, _a, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        target = event.target;
                        form = target.closest('form');
                        element = event.target;
                        productGroupSelect = form.querySelector('select[name="tx_wwproject_locationfinder[productGroup]"]');
                        countrySelect = form.querySelector('select[name="tx_wwproject_locationfinder[country]"]');
                        if (element.checked) {
                            productGroupSelect.removeAttribute('disabled');
                        }
                        else {
                            productGroupSelect.setAttribute('disabled', 'true');
                            productGroupSelect.value = '-1';
                            productLineElement.innerHTML = '';
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        url = countrySelect.getAttribute(this.FILTER_SELECT_ACTION_DATA);
                        formData = new FormData(filterForm);
                        return [4 /*yield*/, fetch(url, {
                                method: 'POST',
                                headers: {
                                    'content-type': 'application/json',
                                },
                                body: JSON.stringify({
                                    serviceLocation: element.checked,
                                    currentCountry: formData.get('tx_wwproject_locationfinder[country]'),
                                }),
                            })];
                    case 2:
                        response = _b.sent();
                        _a = countrySelect;
                        return [4 /*yield*/, response.text()];
                    case 3:
                        _a.innerHTML = _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_3 = _b.sent();
                        throw new Error('An error occurred during the fetch request for calculating the country select options: ' + error_3.message);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    LocationFinderFilter.prototype.scrollToResults = function () {
        var submitButton = document.querySelector("[".concat(this.FILTER_SUBMIT, "]"));
        var results = document.querySelector("[".concat(this.FILTER_RESULT_DATA, "]"));
        if (!submitButton || !results) {
            return;
        }
        submitButton.addEventListener('click', function () {
            results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    };
    return LocationFinderFilter;
}());
exports.default = LocationFinderFilter;
